/** Ввод в млн ₸: «300» → 300 000 000, «12,5» → 12 500 000. */
export function parseMln(s: string): number | null {
  const t = s.replace(/\s/g, '').replace(',', '.');
  if (!t) return 0;
  const value = Math.round(Number(t) * 1e8) / 100;
  return Number.isFinite(value) ? value : null;
}

// В миллионе тенге восемь знаков после запятой соответствуют одному тиыну.
const mlnFormatter = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 8, useGrouping: false });
export const editMln = (v: number | undefined) => (v ? mlnFormatter.format(v / 1e6) : '');

export function FinPlanAmountInput({
  value,
  label,
  onCommit,
}: {
  value: number | undefined;
  label: string;
  onCommit: (value: number) => void;
}) {
  return (
    <input
      defaultValue={editMln(value)}
      inputMode="decimal"
      aria-label={label}
      onBlur={(e) => {
        const raw = e.currentTarget.value;
        // Не переписываем и прежние API-значения с точностью выше тиына без явной правки.
        if (raw === editMln(value)) return;
        const next = parseMln(raw);
        if (next !== null && next !== (value ?? 0)) onCommit(next);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.currentTarget.blur();
      }}
      className="w-full rounded-sm border border-transparent bg-transparent px-1 py-1 text-right hover:border-line focus:border-ink focus:outline-none"
    />
  );
}
